import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import stateCityData from '../town_city.json'; // Import your state and city JSON file
import './CreateHub.css';

const CreateBranch = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
  const [hub, setHub] = useState('');
  const [hubs, setHubs] = useState([]);

  useEffect(() => {
    // Fetch all hubs from the backend
    const fetchHubs = async () => {
      try {
        const response = await axios.get('https://kartikenterprisesindia.co.in/api/users/hub/');
        setHubs(response.data); // Set hubs in state
      } catch (err) {
        setError('Failed to fetch hubs');
      }
    };

    fetchHubs();
  }, []);

  const handleStateChange = (state) => {
    setState(state);
    setCity(''); // Reset city when state changes
  };

  const handleCityChange = (city) => {
    setCity(city);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Get userId from JWT token stored in cookies
    const token = document.cookie.split('; ').find(row => row.startsWith('auth_token='));
    if (!token) {
      setError('Token not found');
      return;
    }

    const decodedToken = jwtDecode(token.split('=')[1]);
    const userId = decodedToken.userId; // assuming userId is in the token

    // Create branch code using the first two letters of state and full city
    const branchCode = `BR-${state.slice(0, 2).toUpperCase()}-${city.toUpperCase()}`;

    try {
      const response = await axios.post('https://kartikenterprisesindia.co.in/api/users/branch/', {
        username,
        password,
        state,
        city,
        hub: hub,  // include the selected hub._id
        branchCode, // include the generated branchCode
        userId,
      });

      if (response.status === 201) {
        alert("Branch registered successfully");
      }
    } catch (error) {
      alert(error.response?.data?.error || "Failed to register Branch");
      console.error(error);
    }
  };

  return (
      <div>
      <h2>Create Branch</h2>
      {error && <div className="error">{error}</div>}
      <form onSubmit={handleSubmit}>
          <div className="row">
          <div className="column50">
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="column50">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          </div>

          <div className="row">
          <div className="column50">
            <select
              value={state}
              onChange={(e) => handleStateChange(e.target.value)}
              required
            >
              <option value="">Select State</option>
              {Object.keys(stateCityData).map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>
          <div className="column50">
            <select
              value={city}
              onChange={(e) => handleCityChange(e.target.value)}
              disabled={!state}
              required
            >
              <option value="">Select City</option>
              {stateCityData[state]?.map((city) => (
                <option key={city} value={city}>
                  {city}
                </option>
              ))}
            </select>
          </div>
          <div className="column50">
          <select
            value={hub}
            onChange={(e) => setHub(e.target.value)}
            required
          >
            <option value="">Select Hub</option>
            {hubs.map((hubItem) => (
              <option key={hubItem._id} value={hubItem._id}>
                {hubItem.code} 
              </option>
            ))}
          </select>
        </div>
        </div>

        {error && <p className="error-message">{error}</p>}
          <button type="submit" className="submit-button" style={{backgroundColor:'blue'}}>
            Create Hub
          </button>
      </form>
    </div>
  );
};

export default CreateBranch;
